import { render, staticRenderFns } from "./BlockType110.vue?vue&type=template&id=45d998fc&scoped=true"
import script from "./BlockType110.vue?vue&type=script&lang=ts"
export * from "./BlockType110.vue?vue&type=script&lang=ts"
import style0 from "./BlockType110.vue?vue&type=style&index=0&id=45d998fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d998fc",
  null
  
)

export default component.exports